import TableSpecs from 'componentSpecs/table.json'
import { useState, ReactNode } from 'react'

import { TTableSkin } from '@/components/table/Table'

import { PktTable, PktTableBody, PktTableDataCell, PktTableHeader, PktTableHeaderCell, PktTableRow } from '..'

export default function Table() {
  const [tableSpecs] = useState(TableSpecs.props)

  const tableData: { label: string; value: string | ReactNode }[] = [
    { label: 'Dato og tid', value: '19.01.2023 08:08' },
    {
      label: 'Status',
      value: (
        <span className="pkt-table__cell-wrapper">
          <span className="pkt-tag pkt-tag--yellow">Ny!</span>
        </span>
      ),
    },
    {
      label: 'Memo',
      value: 'Lorum epsum dhsadksa hd sjkahsa k ak dshakdhska orum epsum dhsadksa hd sjkahsa k ak dshakdhska',
    },
    {
      label: 'Vurdering',
      value: (
        <span className="pkt-table__cell-wrapper">
          <span className="pkt-tag pkt-tag--blue">SVT/VT</span>
          <span className="pkt-tag pkt-tag--yellow">STEMI</span>
        </span>
      ),
    },
    { label: 'Vurdert av', value: 'Ted Mosby' },
  ]

  return (
    <>
      <main
        className="page-main pkt-container"
        style={{ display: 'flex', flexDirection: 'column', rowGap: '1rem', background: 'white' }}
      >
        <h1>Table</h1>
        <h2>Table with ID on rows</h2>
        <PktTable skin="basic" responsiveView id="tableTest">
          <PktTableHeader id="tableHeaderTest">
            <PktTableRow id="tableHeaderRowTest">
              {tableData.map((data, index) => (
                <PktTableHeaderCell id={`tableHeaderCellTest-${index}`}>{data.label}</PktTableHeaderCell>
              ))}
            </PktTableRow>
          </PktTableHeader>
          <PktTableBody id="tableBodyTest">
            {[...Array(3)].map((_, index) => (
              <PktTableRow key={index} id={`tableRowTest-${index}`}>
                {tableData.map((data, i) => (
                  <PktTableDataCell dataLabel={data.label} id={`tableCellTest-${i}`}>
                    {data.value}
                  </PktTableDataCell>
                ))}
              </PktTableRow>
            ))}
          </PktTableBody>
        </PktTable>

        <h2>All combinations of Table</h2>

        {tableSpecs.skin.type.map((skinType: string, index: number) => (
          <>
            <h2>Skin: {`"${skinType}"`}</h2>
            <h3>Density: "default"</h3>
            <section className="component">
              <PktTable skin={skinType as TTableSkin} responsiveView>
                <PktTableHeader>
                  <PktTableRow>
                    {tableData.map((data) => (
                      <PktTableHeaderCell>{data.label}</PktTableHeaderCell>
                    ))}
                  </PktTableRow>
                </PktTableHeader>
                <PktTableBody>
                  {[...Array(3)].map((_, index) => (
                    <PktTableRow key={index}>
                      {tableData.map((data) => (
                        <PktTableDataCell dataLabel={data.label}>{data.value}</PktTableDataCell>
                      ))}
                    </PktTableRow>
                  ))}
                </PktTableBody>
              </PktTable>
            </section>
            <h3>Density: "compact", "responsiveView set to false"</h3>
            <section className="component">
              <PktTable skin={skinType as TTableSkin} compact responsiveView={false}>
                <PktTableHeader>
                  <PktTableRow>
                    {tableData.map((data) => (
                      <PktTableHeaderCell>{data.label}</PktTableHeaderCell>
                    ))}
                  </PktTableRow>
                </PktTableHeader>
                <PktTableBody>
                  {[...Array(3)].map((_, index) => (
                    <PktTableRow key={index}>
                      {tableData.map((data) => (
                        <PktTableDataCell dataLabel={data.label}>{data.value}</PktTableDataCell>
                      ))}
                    </PktTableRow>
                  ))}
                </PktTableBody>
              </PktTable>
            </section>
          </>
        ))}
      </main>
    </>
  )
}
